import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import Amount from './Amount';
import CurrencySelect from './currency-select/CurrencySelect';

const CalculatorBaseForm = ({
  curFrom,
  changeDirection,
  updateCurrencyTo,
  updateCurrencyFrom,
  curTo,
  amount,
  updateAmount,
}) => (
  <Grid container spacing={16}>
    <Grid item xs={12} md={3}>
      <Amount value={amount} onChange={updateAmount} />
    </Grid>

    <Grid item xs={10} md={4}>
      <CurrencySelect
        currency={curFrom}
        id="curFrom"
        label="Start Währung"
        onChange={updateCurrencyFrom}
        title="Start Währung wählen"
      />
    </Grid>

    <Grid item xs={2} md={1} className="change-direction">
      <button onClick={changeDirection}><CachedIcon /></button>
    </Grid>

    <Grid item xs={10} md={4}>
      <CurrencySelect
        currency={curTo}
        id="curTo"
        label="Ziel Währung"
        onChange={updateCurrencyTo}
        title="Ziel Währung wählen"
      />
    </Grid>
  </Grid>
);

CalculatorBaseForm.propTypes = {
  curFrom: PropTypes.instanceOf(Object).isRequired,
  changeDirection: PropTypes.func.isRequired,
  updateCurrencyTo: PropTypes.func.isRequired,
  updateCurrencyFrom: PropTypes.func.isRequired,
  curTo: PropTypes.instanceOf(Object).isRequired,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  updateAmount: PropTypes.func.isRequired,
};


export default CalculatorBaseForm;



// WEBPACK FOOTER //
// ./src/components/calculator/CalculatorBaseForm.js